import auth0 from 'auth0-js';

const clientID = process.env.REACT_APP_CLIENT_ID;
const domain = process.env.REACT_APP_DOMAIN;
const audience = process.env.REACT_APP_AUTH0_AUDIENCE;

// constants
const initialState = {
    isAuthenticated: false,
    authToken: null,
    accessToken: null,
    idTokenPayload: null,
    user: undefined,
    nameOrganization: undefined,
    idOrganization: null,
    loginView: 1,
    loading: false,
    error: null,
    logoOrganization: null,
    loadProfile: false
};

// types
const types = {
    OTP_SENDING_START: 'OTP_SENDING_START',
    OTP_SENT_TO_EMAIL: 'OTP_SENT_TO_EMAIL',
    SET_USER_DATA: 'SET_USER_DATA',
    RESET_AUTH: 'RESET_AUTH',
    SET_LOGIN_VIEW: 'SET_LOGIN_VIEW',
    NEXT_PAGE: 'NEXT_PAGE',
    SET_ORGANIZATION: 'SET_ORGANIZATION',
    SET_LOADING: 'SET_LOADING',
    SET_ERROR_LOGIN: 'SET_ERROR_LOGIN',
    OTP_LOGIN_SUCCESS: 'OTP_LOGIN_SUCCESS',
    GET_TIME_DATA: 'GET_TIME_DATA',
    SET_LOAD_PROFILE: 'SET_LOAD_PROFILE',
    LOGOUT: 'LOGOUT'
};

// reduccers
export default function AuthReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_ERROR_LOGIN:
            return {
                ...state,
                error: action.payload.error,
                loading: false
            };
        case types.OTP_SENDING_START:
            return {
                ...state,
                loading: true
            };
        case types.SET_LOADING:
            return {
                ...state,
                loading: action.payload.loading
            };
        case types.OTP_SENT_TO_EMAIL:
            return {
                ...state,
                loading: false,
                loginView: 2,
                emailUserLogin: action.payload.email
            };
        case types.OTP_LOGIN_SUCCESS:
            return {
                ...state,
                authToken: action.payload.authToken,
                accessToken: action.payload.accessToken,
                idTokenPayload: action.payload.idTokenPayload,
                loginView: 3,
                loading: false,
                isAuthenticated: true
            };
        case types.NEXT_PAGE:
            return {
                ...state,
                loginView: action.payload
            };
        case types.SET_ORGANIZATION:
            return {
                ...state,
                // organization: {
                //     nameOrganization: action.payload.org,
                //     idOrganization: action.payload.idOrganization
                // },
                nameOrganization: action.payload.org,
                idOrganization: action.payload.idOrganization,
                logoOrganization: action.payload.logoOrganization
            };
        case types.SET_USER_DATA:
            return {
                ...state,
                user: { ...state.user, ...action.payload }
            };
        case types.RESET_AUTH:
            // eslint-disable-next-line no-undef
            storage.clearAll();
            return {
                ...state,
                isAuthenticated: false,
                authToken: undefined,
                user: undefined,
                loginView: 1
            };
        case types.GET_TIME_DATA:
            return {
                ...state,
                getTimeData: { ...state.getTimeData, ...action.payload }
            };
        case types.SET_LOAD_PROFILE:
            return {
                ...state,
                loadProfile: true
            };

        case types.LOGOUT:
            return initialState;
        default:
            return state;
    }
}

export const webAuth = new auth0.WebAuth({
    domain,
    clientID,
    responseType: 'token id_token',
    redirectUri: `${window.location.origin}/authorize`,
    scope: 'openid profile email',
    audience: audience
});

export function otpStart({ email }) {
    console.log(window.location.origin);
    return dispatch => {
        console.log('otp start', email);
        dispatch({ type: types.OTP_SENDING_START });

        // data necessary to register the user
        const values = { email, connection: 'email', send: 'code' };

        webAuth.passwordlessStart(values, (error, res) => {
            if (error) {
                console.log('ocurrió un error con el login', error);
                dispatch({
                    type: types.SET_ERROR_LOGIN,
                    payload: error
                });
            } else {
                console.log('Exito!!', res);
                dispatch({
                    type: types.OTP_SENT_TO_EMAIL,
                    payload: { email }
                });
            }
        });
    };
}

export function otpLogin({ email, otp }) {
    return dispatch => {
        // data necessary to start the user session
        const myData = { email, connection: 'email', verificationCode: otp };

        webAuth.passwordlessLogin(myData, err => {
            if (err) {
                console.log('success!', err);
                console.log('success!', email);
                dispatch({
                    type: types.SET_ERROR_LOGIN,
                    payload: { error: err.error }
                });
            } else {
                console.log('error', err);
            }
        });
    };
}

export const joinOrganization = pageNumber => {
    return {
        type: types.NEXT_PAGE,
        payload: pageNumber
    };
};
export const logout = () => {
    return () => {
        webAuth.logout({
            returnTo: `${window.location.origin}`,
            clientID: process.env.REACT_APP_CLIENT_ID
        });
    };
};

//= ============thunks
export function setUserData(data) {
    return { type: types.SET_USER_DATA, payload: data };
}

export function resetAuth() {
    return { type: types.RESET_AUTH };
}

export function authenticateUser(authToken, accessToken, idTokenPayload) {
    return {
        type: types.OTP_LOGIN_SUCCESS,
        payload: { authToken, accessToken, idTokenPayload }
    };
}

export function setOrganization(data) {
    const { organization, idOrganization, logoOrganization } = data;
    return {
        type: types.SET_ORGANIZATION,
        payload: { org: organization, idOrganization, logoOrganization }
    };
}
export function setLoading(value) {
    return {
        type: types.SET_LOADING,
        payload: { loading: value }
    };
}

export function handleLogout() {
    return {
        type: types.LOGOUT
    };
}
